import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { axiosInstance } from '../api/auth';
import { logout as userLogout } from '../store/slices/authSlice';
import { adminLogout } from '../store/slices/adminAuthSlice';
import { toast } from 'react-toastify';
import { NAVIGATION_ROUTE } from '../constants';

const SessionInterceptor = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const interceptor = axiosInstance.interceptors.response.use(
      response => response,
      error => {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
          dispatch(userLogout());
          dispatch(adminLogout());
          toast.error('Session expired.');
          setTimeout(() => {
            navigate(NAVIGATION_ROUTE.home);
          }, 1000);
        }
        return Promise.reject(error);
      }
    );
    return () => axiosInstance.interceptors.response.eject(interceptor);
  }, [dispatch, navigate]);

  return null;
};

export default SessionInterceptor; 